// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1N8-u","cell":"ColumnAccessor_cell__3kw0s","firstCellAccent":"ColumnAccessor_firstCellAccent__3xOwO"};